import React from 'react';


export class RedirectToMercadoPagoButton extends React.Component {
    constructor(props) {
        super(props);
        this.mercadoPagoBtnId = "button-checkout";
    }

    _redirect() {
        const MERCADO_PAGO_CHECKOUT_URL = "https://www.mercadopago.com.ar/checkout/v1/redirect";
        window.location.assign(`${MERCADO_PAGO_CHECKOUT_URL}?pref_id=${this.props.preferenceId}`);
    }

    render() {
        return (
            <div>
                <button id={this.mercadoPagoBtnId} className="main-btn confirm-payment-btn" onClick={() => this._redirect()}>
                    CONFIRMAR
                </button>
            </div>
        );
    }
}